import { render } from "./x5_susteinability.vue?vue&type=template&id=3b9531ab&scoped=true"
import script from "./x5_susteinability.vue?vue&type=script&lang=js"
export * from "./x5_susteinability.vue?vue&type=script&lang=js"

import "./x5_susteinability.vue?vue&type=style&index=0&id=3b9531ab&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b9531ab"]])

export default __exports__